var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
var SchemaElementWrapper = (function (_super) {
    __extends(SchemaElementWrapper, _super);
    function SchemaElementWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SchemaElementWrapper.prototype.render = function () {
        var _a = this.props, container = _a.container, fieldInput = _a.fieldInput, repeatableActions = _a.repeatableActions, contentProps = _a.contentProps;
        var repeatable = contentProps.repeatable, value = contentProps.value, elementKey = contentProps.elementKey;
        var elementContent = null;
        if (fieldInput) {
            if (repeatable && value && repeatableActions) {
                var repeatableValues_1 = value;
                elementContent = repeatableValues_1.map(function (member, index) { return (React.createElement("div", { key: elementKey + "-" + index, className: "df-repeatable-container" },
                    React.createElement(fieldInput, __assign(__assign({}, contentProps), { value: member, className: "df-repeatable-input", index: index })),
                    React.createElement(repeatableActions, __assign(__assign({}, contentProps), { removeVisible: repeatableValues_1.length > 1, index: index })))); });
            }
            else {
                elementContent = React.createElement(fieldInput, contentProps);
            }
        }
        var element = container
            ? React.createElement(container, contentProps, elementContent)
            : elementContent;
        return (React.createElement("div", { className: "df-schema-element" }, element));
    };
    return SchemaElementWrapper;
}(React.Component));
export default SchemaElementWrapper;
